"use client";
import { useEffect } from "react";

/**
 * Freeze the page behind a full-screen overlay while `locked` is true.
 *
 * Pinning the body with a negative top (instead of just overflow:hidden) is
 * what stops iOS Safari from scrolling the page under the overlay, so the
 * scroll offset has to be restored by hand on unlock. The padding-right
 * compensation keeps the layout from jumping sideways on desktop, where
 * hiding the scrollbar would otherwise hand the page ~15px of extra width.
 */
export default function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    const body = document.body;
    const scrollY = window.scrollY;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const prev = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    };

    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflow = "hidden";
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;

    return () => {
      Object.assign(body.style, prev);
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}
